export const IKON_GOLD   = '#F7CB14';
export const SUNSET_GOLD = '#CA972B';
export const YELLOW      = '#F9D84DA8';

export const COOL_BLUE       = '#E5F2F8';
export const BLUE_CREEK      = '#0080BB'; // Base
export const DARK_BLUE_CREEK = '#006695';
export const IKON_BLUE       = '#082241';

export const RED_CREEK = '#AD4A4A'; // Complementary
export const DARK_RED_CREEK = '#8A3A3A';
export const DEFERRED_ORANGE = '#F6A25F';

export const GREEN_CREEK      = '#80BB00'; // Triadic
export const DARK_GREEN_CREEK = '#669500';

export const WHITE       = '#FFFFFF';
export const LIGHT_GREY  = '#f3f3f2';
export const COOL_GREY   = '#D9D9D6';
export const COOLER_GREY = '#C3C3C0';
export const MIDDLE_GREY = '#8E8E8E';  // Form element outlines
export const MUTED_GREY  = '#6D716B';  // De-emphasized label text (AA ~5:1 on white)
export const DARK_GREY   = '#373A36';
export const BLACK       = '#000000';
export const LIGHT_GREEN = '#40af20'

export const SENIOR_GUEST  = '#0B0841';
export const ADULT_GUEST   = '#1A6ED2';
export const TEEN_GUEST    = '#F75A14';
export const CHILD_GUEST   = '#F9D84D';
export const TODDLER_GUEST = '#86B6F0'; // Guest 4 years old or less -- hard to name

export const DARK_TOOLTIP = '#000000CC';
